import React, { useEffect, useState } from 'react';
import DataTable from './DataTable/Table';
import userService from '../../app/services/user.service';
import Loader from '../../UI/loader/loader';

const Dpp = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true); // Set loading to true when fetching starts
    
    const payload = {
      searchvalue: ""
    };
    
    userService.getDppData(payload)
      .then(res => {
        setData(res.data.question_data);
        console.log(res.data.question_data);
        setLoading(false); // Set loading to false when data is received
      })
      .catch(err => {
        console.log(err);
        setLoading(false); // Set loading to false even if there's an error
      });
  }, []);

  const headers = [
    { name: "S.No.", field: "id", sortable: true },
    { name: "QID", field: "qid", sortable: true },
    { name: "Q_Text", field: "q_text", sortable: true },
    { name: "Sequence", field: "question_sequence", sortable: true },
    { name: "Name", field: "exersie_type", sortable: true },
    { name: "Topic", field: "topic_name", sortable: true },
    { name: "Target", field: "target", sortable: true },
    { name: "Session", field: "session", sortable: true },
    { name: "video id", field: "batch", sortable: true },
    { name: "Action", field: "Action", sortable: true },
  ];

  return (
    <div>
      {loading ? (
        <Loader /> // Display loader when loading is true
      ) : (
        <DataTable
          noDataShow={true}
          headerdata={headers}
          data={data}
          type={"dpp"}
        />
      )}
    </div>
  );
};

export default Dpp;